import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; 
import "../ProductDetails/ProductDetails.css";
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import ProductDetailsResult from "../../components/product-details-result/ProductDetailsResult";
import { getImage } from "../../utils/ProductStatus";
import { useDistributor } from "../../hooks/useDistributor";
import useUserInventory from "../../hooks/useUserInventory";

const DistributorProductDetails = () => {
  const { serial } = useParams();
  const [queryText, setQueryText] = useState(serial || "");
  const [result, setResult] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [retailer, setRetailer] = useState(null);
  const [warranty, setWarranty] = useState(null);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [valid, setValid] = useState(false);

  const distributor = useDistributor();
  const { inventory } = useUserInventory();

  const search = async (searchSerial) => {
    if (!searchSerial.trim()) {
      setResult(null);
      setValid(false);
      return;
    }

    try {
      const getSoldItems = distributor.soldItems || [];
      const flag1 = getSoldItems.includes(searchSerial);
      const flag2 = inventory.some(item => item.id === searchSerial);
      setValid(flag1 || flag2);

      const docRef = doc(db, "all-products", searchSerial.trim());
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setResult({ id: docSnap.id, ...docSnap.data() });
      } else {
        setResult(null);
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      setResult(null);
      setValid(false);
    }
  };

  useEffect(() => {
    if (serial) {
      search(serial);
    }
  }, [serial]);

  useEffect(() => {
    if (result?.serialNumber) {
      const fetchCustomerDetails = async () => {
        try {
          const docRef = doc(db, "customers", result.serialNumber);
          const retailerRef = doc(db, "users", result.retailerOrDistributorId);
          const warrantyRef = doc(db, "warranty", result.serialNumber);

          const [docRetailer, docSnap, docWarranty] = await Promise.all([
            getDoc(retailerRef),
            getDoc(docRef),
            getDoc(warrantyRef)
          ]);

          setRetailer(docRetailer.exists() ? { id: docRetailer.id, ...docRetailer.data() } : null);
          setWarranty(docWarranty.exists() ? { id: docWarranty.id, ...docWarranty.data() } : null);
          setCustomer(docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null);
        } catch (error) {
          console.error("Error fetching customer document:", error);
          setRetailer(null);
          setCustomer(null);
          setWarranty(null);
        }
      };
      fetchCustomerDetails();
    }
  }, [result]);

  useEffect(() => {
    if (result?.serialNumber) {
      const fetchFilteredTransactions = async () => {
        try {
          const transactionsRef = collection(db, "transactions");
          const transactionsQuery = query(
            transactionsRef,
            where("serialNumbers", "array-contains", result.serialNumber)
          );

          const transactionsSnapshot = await getDocs(transactionsQuery);
          const transactionList = await Promise.all(
            transactionsSnapshot.docs.map(async (doc) => {
              let data = doc.data();
              
              if (data.fromDistributorId?.path) {
                const fromDistributorDoc = await getDoc(data.fromDistributorId);
                if (fromDistributorDoc.exists()) {
                  data.fromDistributor = fromDistributorDoc.data();
                }
              }
              
              if (data.toEntityId?.path) {
                const toEntityDoc = await getDoc(data.toEntityId);
                if (toEntityDoc.exists()) {
                  data.toEntity = toEntityDoc.data();
                }
              }
              
              return { id: doc.id, ...data };
            })
          );

          transactionList.sort((a, b) => (b.date?.seconds || 0) - (a.date?.seconds || 0));
          setFilteredTransactions(transactionList);
        } catch (err) {
          console.error("Error fetching transactions:", err);
        }
      };
      fetchFilteredTransactions();
    }
  }, [result]);

  return (
    <>
      <div className="search-pd mt-5">
        <input
          className="text-black"
          type="text"
          placeholder="Serial Number"
          onChange={(e) => setQueryText(e.target.value)}
          value={queryText}
        />
        <button onClick={() => search(queryText)}>🔍</button>
      </div>

      {(result && valid) ? (
        <ProductDetailsResult
          brand={result.brand || "N/A"}
          model={result.model || "N/A"}
          imei1={result.imei_1 || "N/A"}
          imei2={result.imei_2 || "N/A"}
          serial={result.serialNumber || "N/A"}
          varient={result.variant || "N/A"}
          status={result.status || "N/A"}
          history={result.history || []}
          customer={customer}
          retailer={retailer}
          warrnty={warranty}
          PhoneImg={getImage({ brand: result.brand, model: result.model })}
          transaction={filteredTransactions}
        />
      ) : queryText ? (
        <p>No results found for "{queryText}"</p>
      ) : null}
    </>
  );
};

export default DistributorProductDetails;
